import React, { useEffect } from 'react';
import './Page.css';

const AccountDeletion = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page-container">
      <div className="page-content">
        <h1 className="page-title">ACCOUNT DELETION</h1>
        
        <div className="page-section">
          <p style={{ color: '#2B3674', opacity: 0.9 }}>
            If you would like to delete your PoppyGrid account and all associated personal data, please follow the steps below:
          </p>
          <ol style={{ color: '#2B3674', opacity: 0.9 }}>
            <li>Go to Settings on the PoppyGrid App.</li>
            <li>Find the option "Delete Account".</li>
            <li>You will get a popup asking you to confirm the deletion.</li>
            <li>Type "delete" to confirm the deletion.</li>
            <li>Click on "Delete" to complete the account deletion process.</li>
          </ol>
        </div>

        <div className="page-section">
          <h2>What Data Will Be Deleted</h2>
          <p style={{ color: '#2B3674', opacity: 0.9 }}>
            When your deletion request is processed, the following data will be permanently removed:
          </p>
          <ul style={{ color: '#2B3674', opacity: 0.9 }}>
            <li>Name</li>
            <li>Email/phone number</li>
            <li>Profile details</li>
            <li>Tags and interests</li>
            <li>Broadcasts</li>
            <li>Messages</li>
            <li>Bookmarked data</li>
            <li>Hotspot related data</li>
            <li>Location data</li>
            <li>Any identifiers associated with your PoppyGrid account</li>
          </ul>
        </div>

        <div className="page-section">
          <h2>What Data May Be Temporarily Retained</h2>
          <p style={{ color: '#2B3674', opacity: 0.9 }}>
            Some data must be retained for security, fraud prevention, or legal compliance:
          </p>
          <ul style={{ color: '#2B3674', opacity: 0.9 }}>
            <li><strong>Security logs</strong> (retained for up to 90 days)</li>
            <li><strong>Legal/compliance records</strong> (retained for up to 1 year, as required by law)</li>
          </ul>
          <p style={{ color: '#2B3674', opacity: 0.9 }}>
            This data is securely stored and cannot be used to identify you after deletion.
          </p>
        </div>

        <div className="page-section">
          <h2>Deletion Timeline</h2>
          <ul style={{ color: '#2B3674', opacity: 0.9 }}>
            <li><strong>Verification:</strong> 0–7 days</li>
            <li><strong>Account + data deletion:</strong> within 30 days after verification</li>
            <li><strong>Retained logs</strong> automatically purged after their required retention period</li>
          </ul>
        </div>

        <div className="page-section">
          <h2>Contact</h2>
          <p style={{ color: '#2B3674', opacity: 0.9 }}>
            If you need help, contact us at <a href="mailto:inquire@poppygrid.com">inquire@poppygrid.com</a>. Please note that the email should be associated with your PoppyGrid account.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AccountDeletion;

